// https://codepen.io/jackrugile/pen/acAgx
// Copyright (c) 2019 by Jack Rugile (https://codepen.io/jackrugile/pen/acAgx)
// Tweaked by Kiempunt
//
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//

var Fireworks = function(canvas, opts){
    /*=============================================================================*/
    /* Utility
    /*=============================================================================*/
    var self = this;
    var rand = function(rMi, rMa){return ~~((Math.random()*(rMa-rMi+1))+rMi);}
    const requestAnimFrame = function(){
        return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(a){window.setTimeout(a,1E3/60)}
    }();

    self.opts = opts || {}
    self.defaults = {
        particles: [],
        fireworks: [],
        fworkSpeed: 2,
        fworkAccel: 4,
        showShockwave: false,
        showTarget: true,
        partCount: 30,
        partSpeed: 5,
        partSpeedVariance: 10,
        partWind: 50,
        partFriction: 5,
        partGravity: 1,
        flickerDensity: 20,
        hueMin: 150,
        hueMax: 200,
        hueVariance: 30,
        lineWidth: 1,
        clearAlpha: 25
    }

    /*=============================================================================*/
    /* Initialize
    /*=============================================================================*/
    self.init = function(){
        self.dt = 0;
        self.oldTime = Date.now();
        self.canvas = canvas;
        self.isRunning = true;

        self.canvas.onselectstart = function() {
            return false;
        };

        const opts = Object.assign({}, self.defaults, self.opts)

        self.canvas.width = self.cw = window.innerWidth;
        self.canvas.height = self.ch = window.innerHeight;

        self.particles = opts.particles;
        self.partCount = opts.partCount;
        self.fireworks = opts.fireworks;
        self.mx = self.cw/2;
        self.my = self.ch/2;
        self.partSpeed = opts.partSpeed;
        self.partSpeedVariance = opts.partSpeedVariance;
        self.partWind = opts.partWind;
        self.partFriction = opts.partFriction;
        self.partGravity = opts.partGravity;
        self.hueMin = opts.hueMin;
        self.hueMax = opts.hueMax;
        self.fworkSpeed = opts.fworkSpeed;
        self.fworkAccel = opts.fworkAccel;
        self.hueVariance = opts.hueVariance;
        self.flickerDensity = opts.flickerDensity;
        self.showShockwave = opts.showShockwave;
        self.showTarget = opts.showTarget;
        self.clearAlpha = opts.clearAlpha;

        self.ctx = self.canvas.getContext('2d');
        self.ctx.lineCap = 'round';
        self.ctx.lineJoin = 'round';
        self.lineWidth = opts.lineWidth;
        // self.bindEvents();
        self.canvasLoop();

        self.canvas.onselectstart = function() {
            return false;
        };


    };

    /*=============================================================================*/
    /* Particle Constructor
    /*=============================================================================*/
    var Particle = function(x, y, hue){
        this.x = x;
        this.y = y;
        this.coordLast = [
          {x: x, y: y},
          {x: x, y: y},
          {x: x, y: y}
        ];
        this.angle = rand(0, 360);
        this.speed = rand(((self.partSpeed - self.partSpeedVariance) <= 0) ? 1 : self.partSpeed - self.partSpeedVariance, (self.partSpeed + self.partSpeedVariance));
        this.friction = 1 - self.partFriction/100;
        this.gravity = self.partGravity/2;
        this.hue = rand(hue-self.hueVariance, hue+self.hueVariance);
        this.brightness = rand(50, 80);
        this.alpha = rand(40,100)/100;
        this.decay = rand(10, 50)/1000;
        this.wind = (rand(0, self.partWind) - (self.partWind/2))/25;
        this.lineWidth = self.lineWidth;
    };

    Particle.prototype.update = function(index){
        var radians = this.angle * Math.PI / 180;
        var vx = Math.cos(radians) * this.speed;
        var vy = Math.sin(radians) * this.speed + this.gravity;
        this.speed *= this.friction;

        this.coordLast[2].x = this.coordLast[1].x;
        this.coordLast[2].y = this.coordLast[1].y;
        this.coordLast[1].x = this.coordLast[0].x;
        this.coordLast[1].y = this.coordLast[0].y;
        this.coordLast[0].x = this.x;
        this.coordLast[0].y = this.y;

        this.x += vx * self.dt;
        this.y += vy * self.dt;

        this.angle += this.wind;
        this.alpha -= this.decay;

        if(this.alpha < .05){
            self.particles.splice(index, 1);
        }
    };

    Particle.prototype.draw = function(){
        var coordRand = (rand(1,3)-1);
        self.ctx.beginPath();
        self.ctx.moveTo(Math.round(this.coordLast[coordRand].x), Math.round(this.coordLast[coordRand].y));
        self.ctx.lineTo(Math.round(this.x), Math.round(this.y));
        self.ctx.closePath();
        self.ctx.strokeStyle = 'hsla('+this.hue+', 100%, '+this.brightness+'%, '+this.alpha+')';
        self.ctx.stroke();

        if(self.flickerDensity > 0){
            var inverseDensity = 50 - self.flickerDensity;
            if(rand(0, inverseDensity) === inverseDensity){
                self.ctx.beginPath();
                self.ctx.arc(Math.round(this.x), Math.round(this.y), rand(this.lineWidth,this.lineWidth+3)/2, 0, Math.PI*2, false)
                self.ctx.closePath();
                var randAlpha = rand(50,100)/100;
                self.ctx.fillStyle = 'hsla('+this.hue+', 100%, '+this.brightness+'%, '+randAlpha+')';
                self.ctx.fill();
            }
        }
    };

    /*=============================================================================*/
    /* Create Particles
    /*=============================================================================*/
    self.createParticles = function(x,y, hue){
        var countdown = self.partCount;
        while(countdown--){
            self.particles.push(new Particle(x, y, hue));
        }
    };

    /*=============================================================================*/
    /* Update Particles
    /*=============================================================================*/
    self.updateParticles = function(){
        var i = self.particles.length;
        while(i--){
            var p = self.particles[i];
            p.update(i);
        }
    };

    /*=============================================================================*/
    /* Draw Particles
    /*=============================================================================*/
    self.drawParticles = function(){
        var i = self.particles.length;
        while(i--){
            var p = self.particles[i];
            p.draw();
        }
    };

    /*=============================================================================*/
    /* Firework Constructor
    /*=============================================================================*/
    var Firework = function(startX, startY, targetX, targetY){
        this.x = startX;
        this.y = startY;
        this.startX = startX;
        this.startY = startY;
        this.hitX = false;
        this.hitY = false;
        this.coordLast = [
          {x: startX, y: startY},
          {x: startX, y: startY},
          {x: startX, y: startY}
        ];
        this.targetX = targetX;
        this.targetY = targetY;
        this.speed = self.fworkSpeed;
        this.angle = Math.atan2(targetY - startY, targetX - startX);
        this.shockwaveAngle = Math.atan2(targetY - startY, targetX - startX)+(90*(Math.PI/180));
        this.acceleration = self.fworkAccel/100;
        this.hue = rand(self.hueMin, self.hueMax);
        this.brightness = rand(50, 80);
        this.alpha = rand(50,100)/100;
        this.lineWidth = self.lineWidth;
        this.targetRadius = 1;
    };

    Firework.prototype.update = function(index){
        self.ctx.lineWidth = this.lineWidth;

        const vx = Math.cos(this.angle) * this.speed;
        const vy = Math.sin(this.angle) * this.speed;
        this.speed *= 1 + this.acceleration;
        this.coordLast[2].x = this.coordLast[1].x;
        this.coordLast[2].y = this.coordLast[1].y;
        this.coordLast[1].x = this.coordLast[0].x;
        this.coordLast[1].y = this.coordLast[0].y;
        this.coordLast[0].x = this.x;
        this.coordLast[0].y = this.y;

        if(self.showTarget){
            if(this.targetRadius < 8){
                this.targetRadius += .25 * self.dt;
            } else {
                this.targetRadius = 1 * self.dt;
            }
        }

        if(this.startX >= this.targetX){
            if(this.x + vx <= this.targetX){
                this.x = this.targetX;
                this.hitX = true;
            } else {
                this.x += vx * self.dt;
            }
        } else {
            if(this.x + vx >= this.targetX){
                this.x = this.targetX;
                this.hitX = true;
            } else {
                this.x += vx * self.dt;
            }
        }

        if(this.startY >= this.targetY){
            if(this.y + vy <= this.targetY){
                this.y = this.targetY;
                this.hitY = true;
            } else {
                this.y += vy * self.dt;
            }
        } else {
            if(this.y + vy >= this.targetY){
                this.y = this.targetY;
                this.hitY = true;
            } else {
                this.y += vy * self.dt;
            }
        }

        if(this.hitX && this.hitY){
            self.createParticles(this.targetX, this.targetY, this.hue);
            self.fireworks.splice(index, 1);
        }
    };

    Firework.prototype.draw = function(){
        self.ctx.lineWidth = this.lineWidth;

        var coordRand = (rand(1,3)-1);
        self.ctx.beginPath();
        self.ctx.moveTo(Math.round(this.coordLast[coordRand].x), Math.round(this.coordLast[coordRand].y));
        self.ctx.lineTo(Math.round(this.x), Math.round(this.y));
        self.ctx.closePath();
        self.ctx.strokeStyle = 'hsla('+this.hue+', 100%, '+this.brightness+'%, '+this.alpha+')';
        self.ctx.stroke();

        if(self.showTarget){
            self.ctx.save();
            self.ctx.beginPath();
            self.ctx.arc(Math.round(this.targetX), Math.round(this.targetY), this.targetRadius, 0, Math.PI*2, false)
            self.ctx.closePath();
            self.ctx.lineWidth = 1;
            self.ctx.stroke();
            self.ctx.restore();
        }

        if(self.showShockwave){
            self.ctx.save();
            self.ctx.translate(Math.round(this.x), Math.round(this.y));
            self.ctx.rotate(this.shockwaveAngle);
            self.ctx.beginPath();
            self.ctx.arc(0, 0, 1*(this.speed/5), 0, Math.PI, true);
            self.ctx.strokeStyle = 'hsla('+this.hue+', 100%, '+this.brightness+'%, '+rand(25, 60)/100+')';
            self.ctx.lineWidth = this.lineWidth;
            self.ctx.stroke();
            self.ctx.restore();
        }
    };

    /*=============================================================================*/
    /* Create Fireworks
    /*=============================================================================*/
    self.createFireworks = function(startX, startY, targetX, targetY){
        self.fireworks.push(new Firework(startX, startY, targetX, targetY));
    };

    /*=============================================================================*/
    /* Update Fireworks
    /*=============================================================================*/
    self.updateFireworks = function(){
        var i = self.fireworks.length;
        while(i--){
            var f = self.fireworks[i];
            f.update(i);
        }
    };

    /*=============================================================================*/
    /* Draw Fireworks
    /*=============================================================================*/
    self.drawFireworks = function(){
        var i = self.fireworks.length;
        while(i--){
            var f = self.fireworks[i];
            f.draw();
        }
    };

    /*=============================================================================*/
    /* Clear Canvas
    /*=============================================================================*/
    self.clear = function(){
        self.particles = [];
        self.fireworks = [];
        self.ctx.clearRect(0, 0, self.cw, self.ch);
    };

    /*=============================================================================*/
    /* Delta
    /*=============================================================================*/
    self.updateDelta = function(){
        var newTime = Date.now();
        self.dt = (newTime - self.oldTime)/16;
        self.dt = (self.dt > 5) ? 5 : self.dt;
        self.oldTime = newTime;
    }

    /*=============================================================================*/
    /* Main Loop
    /*=============================================================================*/
    self.canvasLoop = function(){
        if (self.isRunning) {
            requestAnimFrame(self.canvasLoop, self.canvas);
        }
        self.updateDelta();
        self.ctx.globalCompositeOperation = 'destination-out';
        self.ctx.fillStyle = 'rgba(0,0,0,'+self.clearAlpha/100+')';
        self.ctx.fillRect(0,0,self.cw,self.ch);
        self.ctx.globalCompositeOperation = 'lighter';
        self.updateFireworks();
        self.updateParticles();
        self.drawFireworks();
        self.drawParticles();
    };

    self.start = function(initialLaunchCount) {
        self.init();
        while(initialLaunchCount--){
            const delay = initialLaunchCount * rand(150,200)
            setTimeout(function(){
                self.fireworks.push(new Firework(self.cw/2, self.ch, rand(self.cw/4, self.cw*3/4), rand(50, self.ch/2)-50));
            }, delay);
        }
    }

    self.stop = function() {
        self.running = false
    }

}

const opts = {
    fworkSpeed: 3,
    fworkAccel: 4,
    showShockwave: false,
    showTarget: false,
    partCount: 200,
    partSpeed: 20,
    partSpeedVariance: 15,
    partWind: 6,
    partFriction: 12,
    partGravity: 0.5,
    flickerDensity: 42,
    hueMin: 0,
    hueMax: 60,
    hueVariance: 18,
    lineWidth: 3,
    clearAlpha: 20
}

let fw;
export function start(el) {
    fw = new Fireworks(el, opts)
    fw.start(12)
}

export function stop() {
    fw.stop()
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/elements/fireworks.js